import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/headers/header'
import Footer from "./components/footers/footer";
import PrivateRoute from './privateRoute'
import AdminRoute from './adminRoute'

import './index.scss';

// Layouts
import Home from './pages/home';
//import CreateTournament from "./components/tournament/createTournament";
import Tournaments from './pages/tournaments';
import LandingPager from './pages/landingPager'
import AccessDenied from './pages/403'
import PageNotFound from './pages/404'
import Login from './pages/login'
import Register from './pages/register'
import ForgotPassword from './pages/forgot-password'
import Contact from './pages/contact'
import Dashboard from './pages/dashboard'
import LIFaq from './pages/lifaq'

// Tournament Pages
import EventRegistration from "./components/tournament/eventRegistration";
import JudgeAvailability from "./components/tournament/judgeAvailability";
import TournamentPager from './components/tournament/tournamentPager'
import TournamentRoundPostings from './components/tournament/tournamentRoundPostings'
import TournamentRoom from './components/tournament/tournamentRoom'
import TournamentBallot from './components/tournament/tournamentBallot'
import TournamentCompetitorConflicts from './components/tournament/tournamentCompetitorConflicts'
import TournamentCompetitorBallots from './components/tournament/tournamentCompetitorBallots'

import TournamentAdmin from './components/tournament/tournamentAdmin'
import TournamentAdminAssignments from './components/tournament/admin/tournamentAdminAssignments'
import TournamentAdminRoomJudges from './components/tournament/admin/tournamentAdminRoomJudges'
import TournamentAdminPostings from './components/tournament/admin/tournamentAdminPostings'
import TournamentQuickPostings from './components/tournament/tournamentQuickPostings'
import TournamentAdminDashboard from './components/tournament/admin/tournamentAdminDashboard'
import TournamentAdminCompetitors from './components/tournament/admin/tournamentAdminCompetitors'
import TournamentAdminUserActivity from './components/tournament/admin/tournamentAdminUserActivity'
import TournamentAdminJudges from './components/tournament/admin/tournamentAdminJudges'
import TournamentAdminBallots from './components/tournament/admin/tournamentAdminBallots'
import TournamentAdminAlerts from './components/tournament/admin/tournamentAdminAlerts'
import TournamentAdminAwards from './components/tournament/admin/tournamentAdminAwards'
import TournamentAdminAwardSlides from './components/tournament/admin/tournamentAdminAwardSlides'
import TournamentAdminMessenger from './components/tournament/admin/tournamentAdminMessenger'

import TournamentConfig from './components/tournament/tournamentConfig'
import TournamentConfigEvents from './components/tournament/config/tournamentConfigEvents'
import TournamentConfigRounds from './components/tournament/config/tournamentConfigRounds'
import TournamentConfigPrompts from './components/tournament/config/tournamentConfigPrompts'
import TournamentConfigRoundEvents from './components/tournament/config/tournamentConfigRoundEvents'
import TournamentConfigOptions from './components/tournament/config/tournamentConfigOptions'


//Admin Pages
import MenuList from './admin/menu/list';
import MenuEdit from './admin/menu/edit';

import LandingPageList from './admin/landingPage/list';
import LandingPageEdit from './admin/landingPage/edit';

import TournamentPageList from './admin/tournamentPage/list';
import TournamentPageEdit from './admin/tournamentPage/edit';

import MediaEdit from './admin/media/edit';
import MediaList from './admin/media/list';
import MediaCreate from './admin/media/create';
import MediaRevise from './admin/media/revise';

import UserList from './admin/user/list';
import UserEdit from './admin/user/edit';

import TUserList from './admin/tuser/list';
import TUserEdit from './admin/tuser/edit';


import { ToastContainer  } from 'react-toastify';

class Root extends React.Component {
    constructor(props) {
        super(props);
        this.headerDataChanged = this.headerDataChanged.bind(this)

        this.state = {
            cartChange: 0,
        };
    }

    headerDataChanged() {
        this.setState({cartChange: this.state.cartChange+1});
    }

    render() {
        return(
            <BrowserRouter basename={'/'} >
            <div>
                <Header cartChange={this.state.cartChange}/>
                <ToastContainer autoClose={3500}/>
                <Switch>
                    <Route exact path={`/`} render={(props) => <Home {...props} pid={'5dc5d595a5734966afd02d9e'} onHeaderDataChanged={this.headerDataChanged}/>} />

                    <Route path={`/pages/403`} component={AccessDenied}/>
                    <Route path={`/pages/404`} component={PageNotFound}/>
                    <Route path={`/pages/login`} render={(props) => <Login {...props} onHeaderDataChanged={this.headerDataChanged}/>}/>
                    <Route path={`/pages/register`}  render={(props) => <Register {...props} onHeaderDataChanged={this.headerDataChanged}/>}/>
                    <Route path={`/pages/forgot-password`} component={ForgotPassword}/>
                    <Route path={`/pages/policies`} component={Contact}/>
                    <Route path={`/pages/contact`} component={Contact}/>
                    <Route path={`/pages/lifaq`} component={LIFaq}/>
                    <Route path={`/pages/tournaments`} component={Tournaments}/>

                    <PrivateRoute path={`/pages/dashboard/:operation`} component={Dashboard}/>
                    <PrivateRoute path={`/pages/dashboard`} component={Dashboard}/>

                    {/*Tournament Pages*/}
                    <Route path={`/pages/lp/:pid`} component={LandingPager}/>
                    <Route path={`/pages/tournament/:pid`} component={TournamentPager}/>

                    <PrivateRoute path={`/tournament/events/:pid`} component={EventRegistration}/>

                    <PrivateRoute path={`/tournament/availability/:pid/:roundId/:eventId/:roomId`} component={JudgeAvailability}/>
                    <PrivateRoute path={`/tournament/availability/:pid/:roundId/:eventId`} component={JudgeAvailability}/>
                    <PrivateRoute path={`/tournament/availability/:pid/:roundId`} component={JudgeAvailability}/>
                    <PrivateRoute path={`/tournament/availability/:pid`} component={JudgeAvailability}/>

                    <PrivateRoute path={`/tournament/postings/:pid/:roundId/:eventId/:roomId`} component={TournamentRoundPostings}/>
                    <PrivateRoute path={`/tournament/postings/:pid/:roundId/:eventId`} component={TournamentRoundPostings}/>
                    <PrivateRoute path={`/tournament/postings/:pid/:roundId`} component={TournamentRoundPostings}/>
                    <PrivateRoute path={`/tournament/postings/:pid`} component={TournamentRoundPostings}/>
                    <PrivateRoute path={`/tournament/room/:pid/:roomId`} component={TournamentRoom}/>

                    <PrivateRoute path={`/tournament/competitor/exceptions/:pid`} component={TournamentCompetitorConflicts}/>
                    <PrivateRoute path={`/tournament/competitor/ballots/:pid`} component={TournamentCompetitorBallots}/>

                    <PrivateRoute path={`/tournament/ballot/room/judge/competitor/:pid/:roomId/:judgeId/:competitorId`} component={TournamentBallot}/>
                    <PrivateRoute path={`/tournament/ballot/room/judge/:pid/:roomId/:judgeId`} component={TournamentBallot}/>
                    
                    <PrivateRoute path={`/tournament/quick/postings/:pid`} component={TournamentQuickPostings}/>


                    <AdminRoute path={`/tournament/admin/postings/:pid`} component={TournamentAdminPostings}/>
                    <AdminRoute path={`/tournament/admin/assignments/:pid`} component={TournamentAdminAssignments}/>
                    <AdminRoute path={`/tournament/admin/roomjudges/:pid`} component={TournamentAdminRoomJudges}/>
                    <AdminRoute path={`/tournament/admin/dashboard/:pid`} component={TournamentAdminDashboard}/>
                    <AdminRoute path={`/tournament/admin/competitors/:pid`} component={TournamentAdminCompetitors}/>
                    <AdminRoute path={`/tournament/admin/userActivity/:pid`} component={TournamentAdminUserActivity}/>
                    <AdminRoute path={`/tournament/admin/judges/:pid`} component={TournamentAdminJudges}/>
                    <AdminRoute path={`/tournament/admin/ballots/:pid`} component={TournamentAdminBallots}/>
                    <AdminRoute path={`/tournament/admin/alerts/:pid`} component={TournamentAdminAlerts}/>
                    <AdminRoute path={`/tournament/admin/awards/:pid`} component={TournamentAdminAwards}/>
                    <AdminRoute path={`/tournament/admin/awardslides/:pid`} component={TournamentAdminAwardSlides}/>
                    <AdminRoute path={`/tournament/admin/messenger/:pid`} component={TournamentAdminMessenger}/>
                    <Route path={`/tournament/admin/:pid`} component={TournamentAdmin}/>

                    <Route path={`/tournament/config/options/:pid`} component={TournamentConfigOptions}/>
                    <Route path={`/tournament/config/roundEvents/:pid/:rid`} component={TournamentConfigRoundEvents}/>
                    <Route path={`/tournament/config/events/:pid`} component={TournamentConfigEvents}/>
                    <Route path={`/tournament/config/rounds/:pid`} component={TournamentConfigRounds}/>
                    <Route path={`/tournament/config/prompts/:pid`} component={TournamentConfigPrompts}/>
                    <Route path={`/tournament/config/:pid`} component={TournamentConfig}/>


                    {/*Admin Pages*/}
                    <AdminRoute path={`/admin/menu/list`} component={MenuList} />
                    <AdminRoute path={`/admin/menu/edit`} component={MenuEdit} />

                    <AdminRoute path={`/admin/landingPage/list`} component={LandingPageList} />
                    <AdminRoute path={`/admin/landingPage/edit`} component={LandingPageEdit} />

                    <AdminRoute path={`/admin/tournamentPage/list`} component={TournamentPageList} />
                    <AdminRoute path={`/admin/tournamentPage/edit`} component={TournamentPageEdit} />

                    <AdminRoute path={`/admin/media/list`} component={MediaList} />
                    <AdminRoute path={`/admin/media/edit`} component={MediaEdit} />
                    <AdminRoute path={`/admin/media/create`} component={MediaCreate} />
                    <AdminRoute path={`/admin/media/revise`} component={MediaRevise} />
                    
                    <AdminRoute path={`/admin/user/list`} component={UserList} />
                    <AdminRoute path={`/admin/user/edit`} component={UserEdit} />
                    
                    <AdminRoute path={`/admin/tuser/list`} component={TUserList} />
                    <AdminRoute path={`/admin/tuser/edit`} component={TUserEdit} />

                    {/* <Route exact path="*" component={PageNotFound} /> */}
                    <Route component={PageNotFound} />

                </Switch>
            <Footer />
        </div>
        </BrowserRouter>

    	);        
    }

}

ReactDOM.render(<Root />, document.getElementById('root'));

